import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { AppRoutingModule } from '../app-routing.module';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';

import { FilePondModule, registerPlugin } from 'ngx-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginImagePreview);
registerPlugin(FilePondPluginImageValidateSize);
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

// Register the plugin
import { CoreModule } from '@core';

import { ProfileExhibitorComponent } from './profile-exhibitor.component';
import { loadWidgetConsentConfig } from './widget-config';

@NgModule({
  declarations: [ProfileExhibitorComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    //AppRoutingModule,
    ReactiveFormsModule,

    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatStepperModule,
    MatCardModule,
    MatTooltipModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatRadioModule,

    FilePondModule,

    CoreModule,
  ],
  providers: [
    // Fetch the live consent config (legal text, languages, show flags, links)
    // and patch `environment` BEFORE ngDoBootstrap defines the custom element,
    // so the Legal tab drives the widget without a rebuild.
    {
      provide: APP_INITIALIZER,
      useFactory: loadWidgetConsentConfig,
      deps: [HttpClient],
      multi: true,
    },
  ],
  exports: [ProfileExhibitorComponent],
})
export class ProfileExhibitorModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap(): void {
    const el = createCustomElement(ProfileExhibitorComponent, {
      injector: this.injector,
    });

    customElements.define('phuture-profile-exhibitor', el);
  }
}
